import { TabComponent } from './tab'
import { BaseComponent } from '../base-component'
import { isEnterKey } from '../../utils/key'
import { getTemplateContent } from '../../utils/dom'
import { $el, $list } from 'src/scripts/utils/utils'

const CONTAINER_SELECTOR = `[data-tabs-container]`
const TEMPLATE_SELECTOR = `[data-tabs-elements-template]`
const TAB_SELECTOR = `tab-component, tab-with-dynamic-height`
const TAB_NAME_SELECTOR = `[data-tabs-name]`

export class TabsComponent extends BaseComponent {
  template: HTMLTemplateElement
  templateContent: HTMLElement
  tabs: HTMLElement[]

  constructor() {
    super()

    this.template = $el(TEMPLATE_SELECTOR, this)
    this.templateContent = getTemplateContent(this.template)
    this.tabs = [
      $el(TAB_SELECTOR, this),
      ...$list(TAB_SELECTOR, this.templateContent),
    ]
  }

  mountComponent(): void {
    const names = $list(TAB_NAME_SELECTOR, this)

    names.forEach(name => {
      this.addListener(name, 'keydown', this.handleKeyDown)
      this.addListener(name, 'click', this.handleNameClick)
    })
  }

  handleNameClick = (event: MouseEvent): void => {
    event.preventDefault()

    const target: HTMLElement = (event.target as Element).closest('[data-id]')

    if (target.dataset.id) {
      this.selectTab(target.dataset.id)
    }
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    const target = event.target as HTMLElement

    if (!target.dataset.id) {
      return
    }

    if (isEnterKey(event)) {
      event.preventDefault()
      this.selectTab(target.dataset.id)
    }
  }

  generateTabMap() {
    return this.tabs.reduce((map, tab) => {
      const tabId = tab.dataset.id
      return tabId ? { ...map, [tabId]: tab } : map
    }, {})
  }

  async selectTab(tabId: string): Promise<void> {
    this.updateNameById(tabId)
    await this.showNextTab(tabId)
  }

  updateNameById(tabId: string): void {
    const names = $list(TAB_NAME_SELECTOR, this)

    names.forEach(name => {
      name.classList.toggle('selected', tabId === name.getAttribute('data-id'))
    })
  }

  async showNextTab(tabId: string): Promise<void> {
    const tabMap = this.generateTabMap()
    const tab: TabComponent = tabMap[tabId]
    const id = tab.getAttribute('data-id')
    const container = $el(CONTAINER_SELECTOR, this)

    if (!id || !container) {
      return
    }

    this.dataset.selectedTabId = id
    container.replaceChildren(tab)
    await tab.show()

    const video: HTMLVideoElement = $el('video[autoplay]', tab)
    video?.play()

    this.emit('selectTab', { tabId, tab })
  }

  getNames() {
    return $list(TAB_NAME_SELECTOR, this)
  }
}
